'use strict';
import Component from 'gia/Component';

export default class HomeView extends Component
{
  mount() {
    console.log("Hello world Swup v3!");
  }
}
